export const displayShippingFee = (cost: number): string => {
  if (cost === 0) {
    return 'Free'
  }
  return displayPrice(cost)
}

export const displayPrice = (price: number | undefined): string =>
  price !== undefined ? `$${price.toFixed(2)}` : ''

export const discountPercentage = (
  listPrice: number,
  discountPrice?: number
): number | undefined => {
  if (!discountPrice) {
    return undefined
  }

  const listPriceInCents = listPrice * 100
  const discountPriceInCents = discountPrice * 100
  const discountPercentage =
    ((listPriceInCents - discountPriceInCents) / listPriceInCents) * 100
  return Math.round(discountPercentage - 0.9 + 0.5) // set the threshold for rounding to x.9%
}
